<template>
<main id="main" class="reminder">
  <div class="wrap1160">
    <div class="remind-msg-comp">
      <p v-html="$t('CONTACT_COMPLETION_MESSAGE')"></p>
    </div>
  </div>
</main>
</template>

<script>
import {defineComponent} from '@vue/composition-api';
export default defineComponent({
  props : {
    parent : {
      type    : Object,
      default : Object
    }
  }
})
</script>

<style scoped lang="scss" src="@/assets/scss/style.scss"></style>
